import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ProfileHeader } from "../../../containers";
import "./ProfileLayout.scss";
import { getBalance } from "../../../utils/services/lighthouse";

const ProfileLayout: React.FC = () => {
  useEffect(() => {
    getBalance();
    return () => {};
  }, []);

  return (
    <div className="ProfileLayout">
      <ProfileHeader />
      <div className="ProfileLayout__outletContainer">
        <Outlet />
      </div>
    </div>
  );
};

export default ProfileLayout;
